import { Avatar, AvatarGroup, Box, Grid, Stack, Typography } from '@mui/material'
import TrackRow from '../../track/TrackRow'
import AlbumIcon from '@mui/icons-material/Album'
import HandshakeIcon from '@mui/icons-material/Handshake'
import InterpreterModeIcon from '@mui/icons-material/InterpreterMode'
import PersonOffIcon from '@mui/icons-material/PersonOff'
import MoreHorizIcon from '@mui/icons-material/MoreHoriz'
import CalendarTodayIcon from '@mui/icons-material/CalendarToday'
import PianoIcon from '@mui/icons-material/Piano';
import { useNavigate } from 'react-router-dom'

interface ProjectRowProps {
    album: Album,
    tracks: Track[] | []
}

const ProjectRow = ({album, tracks}: ProjectRowProps) => {
    const navigate = useNavigate()
    var uniqInterpretors = tracks.map(track => track.main_artists)
    .flat()
    .reduce((acc: any, current: any) => { 
        const x = acc.find((item: Artist) => item._id === current._id)
        if (!x) { 
            return acc.concat([current]) 
        } else { 
            return acc 
        }
    }, [])

    var uniqFeaturings = tracks.map(track => track.featured_artists)
    .flat()
    .reduce((acc: any, current: any) => { 
        const x = acc.find((item: Artist) => item._id === current._id)
        if (!x) { 
            return acc.concat([current]) 
        } else { 
            return acc 
        }
    }, [])

    var uniqProducers = tracks.map(track => track.producers)
    .flat()
    .reduce((acc: any, current: any) => { 
        const x = acc.find((item: Artist) => item._id === current._id)
        if (!x) { 
            return acc.concat([current]) 
        } else { 
            return acc 
        }
    }, [])

    const navigateToArtist = (id: string) => {
        navigate(`/artist/${id}`)
    }

    // const navigateToTrack = (id: string) => {
    //     navigate(`/track/${id}`)
    // }

    const navigateToAlbum = (id: string) => {
        navigate(`/album/${id}`)
    }

    const navigateToAlbumTeam = (id: string) => {
        navigate(`/album/${id}/team`)
    }

    return (
        <Grid container sx={{ overflow: 'hidden', minHeight: '44vh', borderRadius: '16px', backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundImage: `url(${album?.apple_artwork_url?.replace('{w}', '800').replace('{h}', '800')}})`}}>
            <Grid size={{xs: 12, md: 12, lg: 12}} sx={{backdropFilter: 'blur(20px) brightness(70%)'}}>
                <Stack direction={'row'}>
                    <Avatar onClick={() => navigateToAlbum(album?._id)} variant='rounded' src={album?.apple_artwork_url?.replace('{w}', '800').replace('{h}', '800')} sx={{cursor: 'pointer', height: '8vw', width: '8vw', display: {xs: 'none', md: 'none', lg: 'flex' }}}/>
                    <Stack direction={'column'} sx={{width: '100%', p: 2}}>
                        <Typography onClick={() => navigateToAlbum(album?._id)} variant='h4' sx={{color: `#${album?.apple_artwork_color1}`, cursor: 'pointer', fontSize: '1.4rem', fontWeight: '700', whiteSpace: 'nowrap'}}>{`${album?.apple_name?.replace('- Single', '').slice(0, 34)}${album?.apple_name?.replace('- Single', '').length > 33 ? '...' : ''}`}</Typography>
                        <Stack direction={'row'} sx={{width: '100%'}}>
                            <Stack direction={'column'} sx={{width: '100%'}}>
                                <Stack direction={'row'} alignItems={'center'}>
                                    <CalendarTodayIcon sx={{color: `#${album?.apple_artwork_color1}`, mt: 2, mb: 2, mr: 2}}/>
                                    <Typography sx={{color: `#${album?.apple_artwork_color1}`, fontWeight: '600', mr: 1, display: {xs: 'none', md: 'none', lg: 'block'}}} >{`Sortie:`}</Typography>
                                    <Typography sx={{color: `#${album?.apple_artwork_color1}`, fontWeight: '400', fontStyle: 'italic'}}>{new Date(album?.apple_release_date).toLocaleDateString()}</Typography>
                                </Stack>
                                <Stack direction={'row'} alignItems={'center'}>
                                    <AlbumIcon sx={{color: `#${album?.apple_artwork_color1}`, mt: 2, mb: 2, mr: 2}}/>
                                    <Typography sx={{color: `#${album?.apple_artwork_color1}`, fontWeight: '600', mr: 1, display: {xs: 'none', md: 'none', lg: 'block'}}} >{`Label:`}</Typography>
                                    <Typography sx={{color: `#${album?.apple_artwork_color1}`, fontWeight: '400', fontStyle: 'italic'}}>{album?.apple_record_label}</Typography>
                                </Stack>
                                <Stack direction={'row'} alignItems={'center'}>
                                    <CalendarTodayIcon sx={{color: `#${album?.apple_artwork_color1}`, mt: 2, mb: 2, mr: 2}}/>
                                    <Typography sx={{color: `#${album?.apple_artwork_color1}`, fontWeight: '600', mr: 1, display: {xs: 'none', md: 'none', lg: 'block'}}} >{album?.apple_genre_names?.length > 1 ? `Styles:` : `Style:`}</Typography>
                                    <Typography sx={{color: `#${album?.apple_artwork_color1}`, fontWeight: '400', fontStyle: 'italic'}}>{album?.apple_genre_names.join(', ')}</Typography>
                                </Stack>
                            </Stack>
                            <Stack direction={'column'} sx={{width: '100%'}}>
                                <Stack direction={'row'} alignItems={'center'}>
                                    <InterpreterModeIcon sx={{color: `#${album?.apple_artwork_color1}`, mt: 2, mb: 2, mr: 2}}/>
                                    <Typography sx={{color: `#${album?.apple_artwork_color1}`, fontWeight: '600', mr: 1, display: {xs: 'none', md: 'none', lg: 'block'}}} >{uniqInterpretors.length > 1 ? `Interprètes` : `Interprète`}</Typography>
                                    <AvatarGroup max={3} total={uniqInterpretors.length} sx={{'& div': {bgcolor: '#08082f'}}} renderSurplus={(surplus) => <Box sx={{cursor: 'pointer'}} onClick={() => navigateToAlbumTeam(album?._id)}>+{surplus.toString()}</Box>}>
                                    {
                                        uniqInterpretors.length > 0 
                                        ? uniqInterpretors
                                            .map((artist: Artist, i: any) => 
                                                <Avatar key={i+Date()} src={artist.avatar_url} onClick={() => navigateToArtist(artist._id)} sx={{cursor: 'pointer'}}/>
                                            )
                                        : <PersonOffIcon htmlColor='#fff' sx={{width: '3vh', height: '3vh'}} />
                                    }
                                    </AvatarGroup>
                                </Stack>
                                <Stack direction={'row'} alignItems={'center'}>
                                    <HandshakeIcon sx={{color: `#${album?.apple_artwork_color1}`, mt: 2, mb: 2, mr: 2}} />
                                    <Typography sx={{color: `#${album?.apple_artwork_color1}`, fontWeight: '600', mr: 1, display: {xs: 'none', md: 'none', lg: 'block'}}} >{uniqFeaturings.length > 1 ? `Featurings` : `Featuring` }</Typography>
                                    <AvatarGroup max={4} total={uniqFeaturings.length} sx={{'& div': {bgcolor: '#08082f'}}} renderSurplus={(surplus) => <Box sx={{cursor: 'pointer'}} onClick={() => navigateToAlbumTeam(album?._id)}>+{surplus.toString()}</Box>}>
                                    {
                                        uniqFeaturings.length > 0 ?
                                        uniqFeaturings
                                        .map((artist: Artist, i: any) => 
                                            <Avatar key={i+Date()} src={artist.avatar_url} onClick={() => navigateToArtist(artist._id)} sx={{cursor: 'pointer'}}/>
                                        )
                                    : <PersonOffIcon htmlColor='#fff' sx={{width: '3vh', height: '3vh'}} />
                                    }
                                    </AvatarGroup>
                                </Stack>
                                <Stack direction={'row'} alignItems={'center'}>
                                    <PianoIcon sx={{color: `#${album?.apple_artwork_color1}`, mt: 2, mb: 2, mr: 2}}/>
                                    <Typography sx={{color: `#${album?.apple_artwork_color1}`, fontWeight: '600', mr: 1, display: {xs: 'none', md: 'none', lg: 'block'}}} >{uniqProducers.length > 1 ? `Producteurs` : `Producteur`}</Typography>
                                    <AvatarGroup max={4} total={uniqProducers.length} sx={{'& div': {bgcolor: '#08082f'}}} renderSurplus={(surplus) => <Box sx={{cursor: 'pointer'}} onClick={() => navigateToAlbumTeam(album?._id)}>+{surplus.toString()}</Box>}>
                                    {
                                        uniqProducers.length > 0 ?
                                        uniqProducers
                                        .map((artist: Artist, i: any) => 
                                            <Avatar key={i+Date()} src={artist.avatar_url} onClick={() => navigateToArtist(artist._id)} sx={{cursor: 'pointer'}}/>
                                        )
                                        : <PersonOffIcon htmlColor='#fff' sx={{width: '3vh', height: '3vh'}} />
                                    }
                                    </AvatarGroup>
                                </Stack>
                            </Stack>
                        </Stack>
                    </Stack>
                </Stack>

                <Grid size={{xs: 12, md: 12, lg: 12}} sx={{maxHeight: '30vh', overflow: 'hidden', overflowY: 'scroll', p: 2}} >
                {
                    tracks.slice(0, 4).map( (track, i) => <TrackRow onClick={null} key={i+Date()} index={i} track={track} maxProducers={50} fromAlbum={true} color={`#${album?.apple_artwork_color1}`}/>)
                }
                {
                    tracks.length > 4 ? <MoreHorizIcon onClick={() => navigateToAlbum(album._id)} htmlColor='#fff' sx={{cursor: 'pointer', m: '0 auto', width: '100%', height: '3vh', '&:hover': { backgroundColor: '#00000060' }}}/> : ''
                }
                </Grid>
            </Grid>

        </Grid>
    )
}

export default ProjectRow